export const isFullStatic = false
export const staticPath = "/home/hhip/staging.absimporttools.com/httpdocs/build/static-json"
export const publicPath = "/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"